import {Component, Input, OnInit} from '@angular/core';
import {BoardProject} from '../../../../../class/lifeproject/board-project';
import {PersonRetirement} from '../../../../../class/lifeproject/retirement/person-retirement';
import {Util} from '../../../../../util/util';
import {ApiService} from '../../../../../service/api.service';

@Component({
  selector: 'app-simple-retirment',
  templateUrl: './simple-retirment.component.html',
  styleUrls: ['./simple-retirment.component.css']
})
export class SimpleRetirmentComponent implements OnInit {

  @Input()
  boardProject: BoardProject;

  @Input()
  retirementDate: any;

  @Input()
  totalGAP: number;

  constructor(private apiService: ApiService) {

  }

  ngOnInit() {
    if (this.boardProject && this.boardProject.personRetirement == null) {
      this.retirement = new PersonRetirement();
    }

    if (this.retirementDate) {
      this.retirement.retirementDate = this.retirementDate;
    }

    if (this.totalGAP) {
      this.retirement.expectedMoney = this.totalGAP;
    }
  }

  get retirement() {
    return this.boardProject.personRetirement;
  }

  set retirement(value: PersonRetirement) {
    this.boardProject.personRetirement = value;
  }

  calRetirement() {
    this.apiService.getRetirementValue(this.retirement).subscribe(value => {
      this.retirement = value;
      this.applyGapPercent();

      // check if integration is already created
      if (this.boardProject.createIntegration) {
        // recreate integration with new values
        this.createIntegration();
      }

    });
  }

  applyGapPercent() {
    if (this.retirement.gapPercent < 100) {
      this.retirement.value = this.retirement.value * (this.retirement.gapPercent / 100);
    }
  }

  createIntegration() {
    this.boardProject.createIntegration = true;
    this.boardProject.tax = 0;
    this.boardProject.futureValue = Util.intRound(this.retirement.value);
    this.boardProject.yearToGoal = this.getGoalYear();
  }

  getGoalYear() {
    const currentDate = Util.getCurrentYear();

    const retirementDate = Util.stringToDate(this.retirement.retirementDate);

    return retirementDate.getFullYear() - currentDate;
  }

}
